import InitiativeApi from '@/api/Initiative'
import type {
  InitiativeFetchParams,
  InitiativeSearchParams,
} from '@/api/Initiative/types.ts'
import type { FetchParams, ParamType } from '@/api/types.ts'
import { queryOptions, useQuery } from '@tanstack/react-query'

export function useFetchInitiative(params: InitiativeFetchParams) {
  return useQuery({
    queryKey: ['fetch-initiative', params],
    queryFn: () => InitiativeApi.fetch([], params),
  })
}

export function getInitiativeQueryOptions(id: ParamType) {
  return queryOptions({
    queryKey: ['get-initiative', id],
    queryFn: () => InitiativeApi.get(id),
  })
}

export function useGetInitiative(id: ParamType) {
  return useQuery(getInitiativeQueryOptions(id))
}

export function useFetchInitiativeAdminUsers(
  id: ParamType,
  params: FetchParams
) {
  return useQuery({
    queryKey: ['fetch-initiative-permissions', id, params],
    queryFn: () => InitiativeApi.fetchAdminUsers([id], params),
  })
}

export function useSearchInitiative(
  initiativeId: ParamType,
  params: InitiativeSearchParams
) {
  return useQuery({
    queryKey: ['search-initiative', initiativeId, params],
    queryFn: () => InitiativeApi.search([initiativeId], params),
    enabled: !!params.search,
  })
}
